import { Tooltip, Box, Chip } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import CancelIcon from '@mui/icons-material/Cancel'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import { QualityControlStatus } from '@services/dtos'
import { QualityControlStatusLabels } from '@utils/constants'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'

interface Props {
  status: QualityControlStatus
  qualityControlDone?: number
  qualityControlTotal?: number
}

const iconByStatus: Record<QualityControlStatus, React.ReactElement> = {
  [QualityControlStatus.NONE]: (
    <RemoveCircleOutlineIcon sx={{ fontSize: 18, color: 'text.disabled' }} />
  ),
  [QualityControlStatus.IN_PROGRESS]: (
    <HourglassEmptyIcon sx={{ fontSize: 18, color: '#e65100' }} />
  ),
  [QualityControlStatus.NON_COMPLIANT]: (
    <CancelIcon sx={{ fontSize: 18, color: '#c62828' }} />
  ),
  [QualityControlStatus.COMPLETE]: (
    <CheckCircleIcon sx={{ fontSize: 18, color: '#459464' }} />
  ),
}

export const ChipQualityControlStatus = ({
  status,
  qualityControlDone,
  qualityControlTotal,
}: Props) => {
  const isInProgress =
    status === QualityControlStatus.IN_PROGRESS &&
    qualityControlTotal != null &&
    qualityControlDone != null

  const isComplete =
    status === QualityControlStatus.COMPLETE &&
    qualityControlDone != null &&
    qualityControlDone > 0

  const label = isInProgress
    ? `En cours (${qualityControlDone}/${qualityControlTotal})`
    : isComplete
    ? `${QualityControlStatusLabels[status]} (${qualityControlDone})`
    : QualityControlStatusLabels[status]

  return (
    <Tooltip title={label} arrow>
      <Box display="inline-flex" alignItems="center" gap={0.5}>
        {iconByStatus[status]}

        {(isInProgress || isComplete) && (qualityControlDone ?? 0) > 0 && (
          <Chip
            label={qualityControlDone}
            icon={<CheckCircleOutlineIcon />}
            color="success"
            size="small"
            variant="outlined"
          />
        )}
      </Box>
    </Tooltip>
  )
}
